import {
    // IAvailabilityByProductAndRange,
    IBookingCheckInOptions,
    ICartItemData,
    ICartItemsByFare,
    ICartItemsByGroup,
    ICartItemsByProduct,
    ICustomerDetail,
    IDropOffLocationOption,
    IPickUpLocationOption,
    IPickUpLocationOptionWithRef,
    IPickupTimeOption,
    ISetCustomerData,
} from "@interfaces";
import { breakpoint, theme } from "@utilities";
import styled, { keyframes } from "styled-components";
import { CheckoutItemsActions } from "./CheckoutActions";
import { useEffect, useMemo, useState } from "react";
import { KeyboardArrowDown } from "@mui/icons-material";
import _ from "lodash";
import {
    formatBookingDatesByProductClass,
    getBookingCheckInOptions,
    getCheckInDateItem,
    getNumPax,
    groupCartItemsByProduct,
    validateCheckoutStep,
    // isAvailabiltyByRange,
} from "../checkoutHelpers";
import { ItemsByProductHeader } from "./ItemByProductHeader";
import { ErrorToast } from "src/Components/toasts/ErrorToast";
import Dropdown from "src/Module/Cart/CustomDropdown";
import { OptionalDataField } from "./OptionalDataField";
import { selectAccount, useAppSelector } from "@redux";
import { externalApi } from "@api";
import {
    Suggestion,
    TravellerSuggestionsBox,
    TravellerSugesstionBoxDesktopView,
} from "./TravellerSugesstionBox";
import { TravellerRemoveBox, TravellerRemoveBoxDesktopView } from "./TravellerRemoveBox";
import { createNewCustomerModal } from "src/Module/Modals";
import { BorderButton } from "src/Module/TourCheckAvail/BookNowButton";
import { PaymentOptionComponent } from "./CheckoutStep3";
import { SuccessToast } from "src/Components/toasts/SuccessToast";
interface ICheckoutTravelerComponentProps {
    quantityIndex: number;
    customers: ICustomerDetail[];
    items: ICartItemData[];
    checkInOptionsMap: { [key: string]: IBookingCheckInOptions };
    onItemsChange: (items: ICartItemData[]) => void;
    onCreateNewCustomer: (customer: ISetCustomerData) => Promise<ICustomerDetail>;
}

const CheckoutTravelerComponent: React.FC<ICheckoutTravelerComponentProps> = ({
    quantityIndex,
    customers,
    items,
    checkInOptionsMap,
    onItemsChange,
    onCreateNewCustomer,
}) => {
    const checkInDateItem = useMemo(() => getCheckInDateItem(items), [items])!;
    const selectedTimeId = useMemo(() => {
        return checkInDateItem.booking_data?.find((bd) => bd.quantityIndex === quantityIndex)
            ?.timeId;
    }, [checkInDateItem, quantityIndex]);
    const numPax: number = useMemo(
        () => (_.isNil(checkInDateItem) ? 0 : getNumPax(checkInDateItem)),
        [checkInDateItem],
    );
    const [shouldShowBookingTimeOptions, setShouldShowBookingTimeOptions] = useState(true);
    const redeemers = useMemo(
        () =>
            _.uniq(
                items
                    .flatMap((item) =>
                        item.booking_data
                            .filter((b) => b.quantityIndex === quantityIndex)
                            .flatMap((bd) => bd.redeemers || []),
                    )
                    .map((r) => r.toString()),
            ),
        [items],
    );
    const travellers = useMemo(() => {
        if (quantityIndex === 2) {
            return customers.filter((c) => redeemers.includes(c.id.toString()));
        }
        return customers.filter((c) => redeemers.includes(c.id.toString()));
    }, [items, customers, redeemers]);

    const filteredSuggestions = useMemo(() => {
        return customers.filter((user) => {
            const isAlreadyAdded = !items
                .flatMap((item) => {
                    return item.booking_data
                        .filter((bd) => bd.quantityIndex === quantityIndex)
                        .flatMap((bd) => bd.redeemers || []);
                })
                .map((r) => r.toString())
                .includes(user.id.toString());
            return isAlreadyAdded;
        });
    }, [items, customers]);

    const checkInOptions = useMemo(
        () => checkInOptionsMap[checkInDateItem.id],
        [checkInOptionsMap, checkInDateItem.id],
    );
    const [timeOptions, setTimeOptions] = useState<{
        displayName: string;
        options: IPickupTimeOption[];
    } | null>(null);
    const [pickUpLocationOptions, setPickUpLocationOptions] = useState<{
        displayName: string;
        options: IPickUpLocationOption[];
    } | null>(null);
    const [dropOffLocationOptions, setDropOffLocationOptions] = useState<{
        displayName: string;
        options: IDropOffLocationOption[];
    } | null>(null);
    const [countriesData, setCountriesData] = useState<any[]>([]);
    const { account } = useAppSelector(selectAccount);

    const isAccountIncomplete = !(
        account?.first_name &&
        account?.last_name &&
        account?.email &&
        account?.phone_number &&
        account?.post_code &&
        account?.country_code
    );

    const [isTravellerSugesstionOpen, setIsTravellerSugesstionOpen] = useState(false);
    const [isTravellerRemoveOpen, setIsTravellerRemoveOpen] = useState(false);
    const [selectedSuggestion, setSelectedSuggestion] = useState<Suggestion | null>(null);


    const openTravellerSugesstionBox = () => setIsTravellerSugesstionOpen(true);
    const closeTravellerSugesstionBox = () => {
        setIsTravellerSugesstionOpen(false);
        setSelectedSuggestion(null);
    };
    const openTravellerRemoveBox = () => setIsTravellerRemoveOpen(true);
    const closeTravellerRemoveBox = () => {
        setIsTravellerRemoveOpen(false);
        setSelectedSuggestion(null);
    };

    const onSelectTraveller = (selectedSuggestion: Suggestion | null) => {
        if (selectedSuggestion) {
            onItemsChange(
                items.map((item) => {
                    return {
                        ...item,
                        booking_data: item.booking_data.map((bd) => {
                            if (bd.quantityIndex === quantityIndex) {
                                const newRedeemers = _.uniq([
                                    ...(bd.redeemers || []),
                                    Number(selectedSuggestion.id),
                                ]);
                                return {
                                    // clear other fields if first traveller added
                                    ...(newRedeemers.length === 1 ? {} : bd),
                                    redeemers: newRedeemers,
                                    timeId: bd.timeId,
                                    quantityIndex: bd.quantityIndex,
                                };
                            }
                            return bd;
                        }),
                    };
                }),
            );
            closeTravellerSugesstionBox();
        }
    };

    const onRemoveTraveller = (travellerId: number) => {
        let shouldCloseSheet = false;

        onItemsChange(
            items.map((item) => {
                return {
                    ...item,
                    booking_data: item.booking_data.map((bd) => {
                        if (bd.quantityIndex === quantityIndex) {
                            const redeemers: number[] = _.uniq(
                                bd.redeemers?.filter((r) => r !== Number(travellerId)) ?? [],
                            );

                            if (redeemers.length === 0) {
                                shouldCloseSheet = true;
                            }

                            return {
                                redeemers,
                                timeId: bd.timeId,
                                quantityIndex: bd.quantityIndex,
                                // clear other fields if no traveller left
                                ...(redeemers.length === 0 ? {} : bd),
                            };
                        }
                        return bd;
                    }),
                };
            }),
        );

        if (shouldCloseSheet) {
            closeTravellerRemoveBox();
        }
    };

    const onTimeChange = (timeId: string) => {
        onItemsChange(
            items.map((item) => {
                return {
                    ...item,
                    booking_data: item.booking_data.map((bd) => {
                        if (bd.quantityIndex === quantityIndex) {
                            return {
                                timeId,
                                quantityIndex: bd.quantityIndex,
                                redeemers: bd.redeemers,
                                optionalData: bd.optionalData,
                                // do not set other fields since time id resets other fields
                            };
                        }
                        return bd;
                    }),
                };
            }),
        );
    };
    const onPickUpLocationChange = (pickUpIdStr: string | null) => {
        if (!pickUpIdStr) return;
        const pickUpId = pickUpIdStr;
        const selectedPickUpLocation = pickUpLocationOptions?.options.find(
            (opt) => String(opt.id) === String(pickUpId),
        );
        onItemsChange(
            items.map((item) => {
                return {
                    ...item,
                    booking_data: item.booking_data.map((bd) => {
                        if (bd.quantityIndex === quantityIndex) {
                            return {
                                ...bd,
                                pickupId: selectedPickUpLocation?.id,
                                pickupLocation: selectedPickUpLocation?.displayName,
                            };
                        }
                        return bd;
                    }),
                };
            }),
        );
    };
    const onDropOffChange = (dropoffId: string | null) => {
        if (!dropoffId) return;
        const dropOffLocation = dropOffLocationOptions?.options.find((opt) => opt.id === dropoffId);
        onItemsChange(
            items.map((item) => {
                return {
                    ...item,
                    booking_data: item.booking_data.map((bd) => {
                        if (bd.quantityIndex === quantityIndex) {
                            return {
                                ...bd,
                                dropoffId: dropOffLocation?.id,
                                dropoffLocation: dropOffLocation?.displayName,
                            };
                        }
                        return bd;
                    }),
                };
            }),
        );
    };

    const onOptionalChange = (fieldId: number, value: string) => {
        onItemsChange(
            items.map((item) => {
                return {
                    ...item,
                    booking_data: item.booking_data.map((bd) => {
                        if (bd.quantityIndex === quantityIndex) {
                            return {
                                ...bd,
                                optionalData: {
                                    ...(bd.optionalData ?? {}),
                                    [fieldId]: value,
                                },
                            };
                        }
                        return bd;
                    }),
                };
            }),
        );
    };

    // Load countries data once
    useEffect(() => {
        externalApi.getCountriesDate().then((res) => {
            setCountriesData(res.data);
        });
    }, []);

    useEffect(() => {
        if (checkInOptions) {
            const timeLabel =
                checkInOptions.pickupTimes.map((pt) => pt.displayName).at(0) ?? "Time";
            const timeOptions: IPickupTimeOption[] = checkInOptions.pickupTimes
                .flatMap((pt) => pt.options)
                .map((pt) => ({
                    id: pt.id,
                    displayName: pt.displayName,
                    isDefault: false,
                    downstreamTimeRef: pt.downstreamTimeRef,
                }));

            // hide booking time options if only one time option is available and that is daily availability
            if (
                timeOptions.length === 1 &&
                timeOptions.at(0)?.displayName.trim().toLocaleLowerCase() === "daily availability"
            ) {
                if (shouldShowBookingTimeOptions) {
                    setShouldShowBookingTimeOptions(false);
                }
            }

            setTimeOptions({ displayName: timeLabel, options: timeOptions });
        } else {
            setTimeOptions(null);
        }
    }, [checkInOptions]);

    useEffect(() => {
        const selectedTimeOption = timeOptions?.options.find(
            (opt) => opt.id.toString() === selectedTimeId,
        );
        if (checkInOptions && selectedTimeOption) {
            const pickupLocationLabel =
                checkInOptions.pickupLocations.map((pl) => pl.displayName).at(0) ??
                "Pickup Location";
            const pickupLocationOptions: IPickUpLocationOptionWithRef[] =
                checkInOptions.pickupLocations
                    .filter((pl) => pl.upstreamTimeRef === selectedTimeOption.downstreamTimeRef)
                    .flatMap((pl) =>
                        pl.options.map((opt) => ({
                            id: opt.id,
                            displayName: opt.displayName,
                            isDefault: false,
                            upstreamTimeRef: pl.upstreamTimeRef,
                        })),
                    );
            const dropoffLocationLabel =
                checkInOptions.dropoffLocations.map((dl) => dl.displayName).at(0) ??
                "Dropoff Location";
            const dropoffLocationOptions: IDropOffLocationOption[] = checkInOptions.dropoffLocations
                .filter((dl) => dl.upstreamTimeRef === selectedTimeOption.downstreamTimeRef)
                .flatMap((dl) =>
                    dl.options.map((opt) => ({
                        id: opt.id,
                        displayName: opt.displayName,
                        isDefault: false,
                        upstreamTimeRef: dl.upstreamTimeRef,
                    })),
                );
            setPickUpLocationOptions({
                displayName: pickupLocationLabel,
                options: pickupLocationOptions,
            });
            setDropOffLocationOptions({
                displayName: dropoffLocationLabel,
                options: dropoffLocationOptions,
            });
        } else {
            setPickUpLocationOptions(null);
            setDropOffLocationOptions(null);
        }
    }, [checkInOptions, timeOptions, selectedTimeId]);

    const handleSelectSuggestion = (s: Suggestion) =>
        setSelectedSuggestion((prev) => (prev?.id === s.id ? null : s));
    return (
        <>
            <TravelerContainer>
                <div className="listCount">{quantityIndex}</div>
                <Traveller>
                    {travellers.length ? (
                        <div
                            style={{
                                display: "flex",
                                flex: 1,
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            {travellers.map((t) => `${t.first_name} ${t.last_name}`).join(", ")}{" "}
                            <StyledArrow
                                onClick={openTravellerRemoveBox}
                                isOpen={isTravellerRemoveOpen}
                            />
                        </div>
                    ) : (
                        <div className="addTraveller" onClick={openTravellerSugesstionBox}>
                            <img src="/images/Add.svg" alt="add" />
                            <h3>Add Traveller(s)</h3>
                        </div>
                    )}
                </Traveller>
            </TravelerContainer>
            {travellers.length > 0 && numPax < travellers.length && (
                <div style={{ alignSelf: "flex-end", marginTop: "10px" }}>
                    <button
                        style={{ fontSize: "14px", color: "#31B4B9", fontWeight: "600" }}
                        onClick={openTravellerSugesstionBox}
                    >
                        +Add
                    </button>
                </div>
            )}
            {travellers.length > 0 &&
                (((timeOptions?.options.length ?? 0) > 0 && shouldShowBookingTimeOptions) ||
                    (pickUpLocationOptions && pickUpLocationOptions.options.length > 0) ||
                    (dropOffLocationOptions && dropOffLocationOptions.options.length > 0) ||
                    checkInDateItem.booking_details.optionalFields?.length > 0) && (
                    <TravelerInfo>
                        <h6>Booking Details</h6>
                        {shouldShowBookingTimeOptions && timeOptions && timeOptions.options.length > 0 && (
                            <Dropdown
                                key={`time-${quantityIndex}`}
                                options={timeOptions.options.map((o) => ({
                                    label: o.displayName,
                                    value: o.id.toString(),
                                }))}
                                placeholder={timeOptions.displayName}
                                onChange={onTimeChange}
                                value={
                                    checkInDateItem.booking_data.find(
                                        (bd) => bd.quantityIndex === quantityIndex,
                                    )?.timeId || ""
                                }
                            />
                        )}
                        {pickUpLocationOptions && pickUpLocationOptions.options.length > 0 && (
                            <Dropdown
                                key={`pickup-${quantityIndex}`}
                                options={pickUpLocationOptions.options.map((o) => ({
                                    label: o.displayName,
                                    value: o.id.toString(),
                                }))}
                                placeholder={pickUpLocationOptions.displayName}
                                onChange={onPickUpLocationChange}
                                value={
                                    checkInDateItem.booking_data
                                        .find((bd) => bd.quantityIndex === quantityIndex)
                                        ?.pickupId?.toString() ?? ""
                                }
                            />
                        )}
                        {dropOffLocationOptions && dropOffLocationOptions.options.length > 0 && (
                            <Dropdown
                                key={`dropoff-${quantityIndex}`}
                                options={dropOffLocationOptions.options.map((o) => ({
                                    label: o.displayName,
                                    value: o.id.toString(),
                                }))}
                                placeholder={dropOffLocationOptions.displayName}
                                onChange={onDropOffChange}
                                value={
                                    checkInDateItem.booking_data.find(
                                        (bd) => bd.quantityIndex === quantityIndex,
                                    )?.dropoffId || ""
                                }
                            />
                        )}
                        {checkInDateItem.booking_details.optionalFields?.map((of) => (
                            <OptionalDataField
                                key={of.optionalFieldId}
                                optionalField={of}
                                value={
                                    checkInDateItem.booking_data.find(
                                        (bd) => bd.quantityIndex === quantityIndex,
                                    )?.optionalData?.[of.optionalFieldId] || ""
                                }
                                onChange={(v) => onOptionalChange(of.optionalFieldId, v)}
                            />
                        ))}
                    </TravelerInfo>
                )}
            <TravellerSuggestionsBox
                isOpen={isTravellerSugesstionOpen}
                onClose={closeTravellerSugesstionBox}
                suggestions={filteredSuggestions}
                selectedSuggestion={selectedSuggestion}
                onSelect={handleSelectSuggestion}
                onAdd={() => onSelectTraveller(selectedSuggestion)}
                countriesData={countriesData}
                isAccountIncomplete={isAccountIncomplete}
                onCreateNew={async () => {
                    try {
                        const result = await createNewCustomerModal({
                            loadCountries: () =>
                                externalApi.getCountriesDate().then((resp) => resp.data),
                        });
                        if (!result) return;
                        const createdCustomer = await onCreateNewCustomer(result);
                        onSelectTraveller(createdCustomer);
                        setIsTravellerSugesstionOpen(false);
                        SuccessToast({ Message: "New customer created" });
                    } catch (error: any) {
                        ErrorToast({ Message: error.title });
                    }
                }}
            />
            <TravellerSugesstionBoxDesktopView
                isOpen={isTravellerSugesstionOpen}
                onClose={closeTravellerSugesstionBox}
                suggestions={filteredSuggestions}
                selectedSuggestion={selectedSuggestion}
                onSelect={handleSelectSuggestion}
                onAdd={() => onSelectTraveller(selectedSuggestion)}
                countriesData={countriesData}
                isAccountIncomplete={isAccountIncomplete}
                onCreateNew={async () => {
                    try {
                        const result = await createNewCustomerModal({
                            loadCountries: () =>
                                externalApi.getCountriesDate().then((resp) => resp.data),
                        });
                        if (!result) return;
                        const createdCustomer = await onCreateNewCustomer(result);
                        onSelectTraveller(createdCustomer);
                        setIsTravellerSugesstionOpen(false);
                        SuccessToast({ Message: "New customer created" });
                    } catch (error: any) {
                        ErrorToast({ Message: error.title });
                    }
                }}
            />
            <TravellerRemoveBox
                isOpen={isTravellerRemoveOpen}
                onClose={closeTravellerRemoveBox}
                suggestions={travellers}
                onRemove={onRemoveTraveller}
                countriesData={countriesData}
            />
            <TravellerRemoveBoxDesktopView
                isOpen={isTravellerRemoveOpen}
                onClose={closeTravellerRemoveBox}
                suggestions={travellers}
                onRemove={onRemoveTraveller}
                countriesData={countriesData}
            />
        </>
    );
};

const TravelerContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    .listCount {
        width: 32px;
        height: 32px;
        line-height: 30px;
        text-align: center;
        background-color: #f4f6f7;
        border-radius: 50%;
        font-weight: 600;
    }
`;

const Traveller = styled.div`
    flex: 1;
    border: 1px solid #c3c9d0;
    border-radius: 8px;
    gap: 10px;
    padding: 8px 20px;
    color: #31b4b9;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: Plus Jakarta Sans;
    height: 48px;

    .addTraveller {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        h3 {
            font-size: 16px;
            font-weight: 600;
        }
    }
`;

const TravelerInfo = styled.div`
    margin-left: 40px;
    display: flex;
    gap: 8px;
    flex-direction: column;
    margin-top: 10px;
    h6 {
        font-size: 14px;
    }
`;

const StyledArrow = styled(KeyboardArrowDown)<{ isOpen: boolean }>`
    transition: transform 0.5s;
    transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0deg)")};
    color: #31b4b9;
`;

interface ICartItemsByGroupProps extends ICartItemsByGroup {
    productClass: string;
    customers: ICustomerDetail[];
    checkInOptionsMap: { [key: string]: IBookingCheckInOptions };
    onItemsChange: (items: ICartItemData[]) => void;
    onCreateNewCustomer: (customer: ISetCustomerData) => Promise<ICustomerDetail>;
    group_id: string | null;
}

const CartItemGroupComponent = (props: ICartItemsByGroupProps) => {
    const { items, productClass, customers } = props;
    const bookingQuantity = Math.max(...items.map((i) => i.booking_quantity));

    return (
        <CartItemRowContainer>
            <DateText>
                {formatBookingDatesByProductClass(
                    items.map((i) => i.booking_date),
                    productClass,
                )}
            </DateText>
            {_.range(1, bookingQuantity + 1).map((quantityIndex) => {
                return (
                    <>
                        <CheckoutTravelerComponent
                            key={quantityIndex}
                            {...props}
                            quantityIndex={quantityIndex}
                            customers={customers}
                        />
                    </>
                );
            })}
        </CartItemRowContainer>
    );
};

const CartItemRowContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
`;

const DateText = styled.p`
    font-size: 12px;
    font-weight: 600;
    font-family: Plus Jakarta Sans;
    color: #232b2b;
    margin: 4px 0px 8px 0px;
    text-decoration: underline;
    text-underline-offset: 3px;
`;

interface ICartItemsByFareProps extends ICartItemsByFare {
    productClass: string;
    customers: ICustomerDetail[];
    checkInOptionsMap: { [key: string]: IBookingCheckInOptions };
    onItemsChange: (items: ICartItemData[]) => void;
    onCreateNewCustomer: (customer: ISetCustomerData) => Promise<ICustomerDetail>;
}

const CartItemsByFareComponent = (props: ICartItemsByFareProps) => {
    return (
        <div>
            <div className="fareName">{props.name}</div>
            {props.itemsByGroup.map((itemByGroup, groupIndex) => {
                return (
                    <CartItemGroupComponent
                        key={groupIndex}
                        {...props}
                        group_id={itemByGroup.group_id}
                        items={itemByGroup.items}
                        customers={props.customers}
                    />
                );
            })}
        </div>
    );
};

interface ICartItemsByProductProps extends ICartItemsByProduct {
    customers: ICustomerDetail[];
    onItemsChange: (items: ICartItemData[]) => void;
    onCreateNewCustomer: (customer: ISetCustomerData) => Promise<ICustomerDetail>;
    checkInOptionsMap: { [key: string]: IBookingCheckInOptions };
}

const CartItemsByProduct = (props: ICartItemsByProductProps) => {
    return (
        <Info className="infoWrapper">
            <div className="info">
                <ItemsByProductHeader {...props} showDeleteButton={false} />
                <Border />
                {props.itemsByFare.map((itemByFare, fareIndex) => {
                    return (
                        <CartItemsByFareComponent
                            key={fareIndex}
                            {...props}
                            id={itemByFare.id}
                            name={itemByFare.name}
                            itemsByGroup={itemByFare.itemsByGroup}
                            bookingSystem={itemByFare.bookingSystem}
                            customers={props.customers}
                        />
                    );
                })}
            </div>
        </Info>
    );
};

export const Info = styled.div`
    background-color: ${(props) => props.theme.colors.gray_6};
    padding-bottom: 0 !important;
    margin-bottom: 16px;
    .info {
        display: flex;
        flex-direction: column;
        background-color: #fff;
        padding: 16px;
        border-radius: 8px;
        .main {
            display: flex;
            gap: 12px;
        }
        .img {
            position: relative;
            cursor: pointer;
            height: 64px;
            width: 64px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
                border-radius: 8px;
            }
        }
        .info-container {
            display: flex;
            justify-content: space-between;
            width: 90%;
            ${breakpoint.breakOnlyMobile`
                width: auto;
            `}
        }
        .price-container {
            border: 1px solid #c3c9d0;
            border-radius: 8px;
            display: flex;
            justify-content: space-between;
            padding: 8px 20px;
            align-items: center;
            .price {
                display: flex;
                flex-direction: column;
                color: #6e7375;
                font-size: 12px;
                span {
                    color: #000;
                    font-size: 18px;
                }
            }
            .quantity {
                color: #6e7375;
                font-size: 12px;
                display: flex;
                align-items: center;
                gap: 10px;
                span {
                    font-size: 20px;
                    color: #1f2937;
                    width: 18px;
                    text-align: center;
                }
            }
        }
        .fareName {
            font-size: 18px;
            font-weight: 600;
        }
    }
    .name-container {
        display: flex;
        flex-direction: column;
        gap: 6px;
        .title {
            width: 100%;
            font-size: 14px;
            font-weight: 600;
            line-height: 23px;
            cursor: pointer;
            color: #131214;
            text-decoration: underline;
            text-underline-offset: 1px;

            @media (min-width: 375px) {
                width: 200px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            @media (min-width: 425px) {
                width: 250px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            ${breakpoint.breakLarge`
                font-size: 18px;
                width: auto;
                overflow: visible;
                text-overflow: clip;
                white-space: normal;
            `}
        }
        .sub-title {
            color: #6e7375;
            font-size: 12px;
            line-height: 14px;
            @media (min-width: 375px) {
                width: 200px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            @media (min-width: 425px) {
                width: 250px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            ${breakpoint.breakLarge`
                width: auto;
                overflow: visible;
                text-overflow: clip;
                white-space: normal;
            `}
        }
        .location {
            display: flex;
            align-items: center;
            gap: 6px;
            color: #3c3c3c;
            font-size: 12px;
            font-weight: 500;
        }
    }
`;

export const Border = styled.div`
    border-top: 1px solid #e6e9eb;
    margin: 10px 0px 14px 0px;
`;

interface IPaymentOptionProps {
    isOpen: boolean;
    onClose: () => void;
    handleOrderCreate: (paymentType: string) => Promise<void>;
    onOrderCreateSuccess?: () => void;
}

export const PaymentOptionBottomSheet = (props: IPaymentOptionProps) => {
    return (
        <>
            <PaymentOverlay hidden={!props.isOpen} onClick={props.onClose} />
            <PaymentBottomSheet>
                <PaymentOptionComponent {...props} />
            </PaymentBottomSheet>
        </>
    );
};

export const PaymentOptionBottomSheetDesktopView = (props: IPaymentOptionProps) => {
    return (
        <PaymentPopup onClick={props.onClose}>
            <Popup onClick={(e) => e.stopPropagation()}>
                <PaymentOptionComponent {...props} />
            </Popup>
        </PaymentPopup>
    );
};

const PaymentPopup = styled.div`
    ${breakpoint.breakOnlyMobile`
        display: none;
    `}
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 15;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Popup = styled.div`
    background: #fff;
    border-radius: 8px;
    padding: 30px 30px 0px 30px;
    width: 700px;
`;

const paymentSlideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const PaymentOverlay = styled.div`
    display: none;
    ${[breakpoint.breakMobile, breakpoint.breakSmall].map(
        (breakpointFn) => breakpointFn`
    display: block;`,
    )}
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 10;
    cursor: pointer;
`;

const PaymentBottomSheet = styled.div`
    display: none;
    ${[breakpoint.breakMobile, breakpoint.breakSmall].map(
        (breakpointFn) => breakpointFn`
        display: block;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 15;
        background: #fff;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
        animation: ${paymentSlideUp} 0.3s ease-out;
        padding: 30px 16px 0px 16px;

        .details-container{
            display: flex;
            flex-direction: column;
            gap: 20px;
            margin-bottom: 30px;
            h2 {
                font-size: 20px;
                font-weight: 600;
            }
            .details {
                display : flex;
                align-items : center;
                gap : 16px;
                div{
                    display : flex;
                    flex-direction : column;
                    gap : 6px;
                    h1{
                        font-size : 24px;
                        font-weight : 600;  
                    }
                    p{
                        font-size : 12px;
                        color : #6E7375;
                    }
                }
            }
            
        }
    `,
    )}
`;

interface ICheckoutStep2Props {
    items: ICartItemData[];
    customers: ICustomerDetail[];
    moveTo: (step: number) => void;
    onItemsSave: (items: ICartItemData[]) => Promise<void>;
    onCreateNewCustomer: (customer: ISetCustomerData) => Promise<any>;
    handleOrderCreate: (paymentType: string) => Promise<void>;
    onOrderCreateSuccess?: () => void;
}

export const CheckoutStep2 = ({
    items,
    customers,
    onItemsSave,
    onCreateNewCustomer,
    handleOrderCreate,
    onOrderCreateSuccess,
}: ICheckoutStep2Props) => {
    const [cartItems, setCartItems] = useState<ICartItemData[]>(() => items);
    const itemsByProduct = useMemo(() => groupCartItemsByProduct(cartItems), [cartItems]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPayNow, setShouldShowPayNow] = useState(false);
    const [checkInOptionsMap, setCheckInOptionsMap] = useState<{
        [key: string]: IBookingCheckInOptions;
    }>({});

    useEffect(() => {
        // load checkin options for each check in date item
        itemsByProduct.forEach((itemByProduct) => {
            itemByProduct.itemsByFare.forEach((itemByFare) => {
                itemByFare.itemsByGroup.forEach((itemByGroup) => {
                    const checkInDateItem = getCheckInDateItem(itemByGroup.items);
                    if (checkInDateItem) {
                        getBookingCheckInOptions(checkInDateItem).then((checkInOptions) => {
                            if (checkInOptions) {
                                setCheckInOptionsMap((prev) => ({
                                    ...prev,
                                    [checkInDateItem.id]: checkInOptions,
                                }));
                            }
                        });
                    }
                });
            });
        });
    }, [itemsByProduct]);

    const handleGroupItemsChange = (updatedItems: ICartItemData[]) => {
        setCartItems(
            cartItems.map((cartItem) => {
                const updateItem = updatedItems.find((item) => item.id === cartItem.id);
                if (updateItem) {
                    return updateItem;
                }
                return cartItem;
            }),
        );
    };

    const handleSaveItems = async (shouldGoToNextStep: boolean) => {
        try {
            setIsSubmitting(true);
            // TODO: run validation
            if (shouldGoToNextStep) {
                const validation = validateCheckoutStep(
                    itemsByProduct,
                    _.values(checkInOptionsMap),
                );
                if (!validation.isValid) {
                    ErrorToast({ Message: validation.message! });
                    return;
                }
            }
            await onItemsSave(cartItems);
            SuccessToast({ Message: "Cart Updated successfully" });
            if (shouldGoToNextStep) {
                setShouldShowPayNow(true);
            }
        } catch (error) {
            console.error("Error saving items:", error);
            ErrorToast({ Message: "Please complete all required fields before proceeding" });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Container>
            <div className="cartWrapper">
                {itemsByProduct.map((itemByProduct, productIndex) => {
                    return (
                        <CartItemsByProduct
                            key={productIndex}
                            productId={itemByProduct.productId}
                            name={itemByProduct.name}
                            productClass={itemByProduct.productClass}
                            productImagePath={itemByProduct.productImagePath}
                            itemsByFare={itemByProduct.itemsByFare}
                            startLocationName={itemByProduct.startLocationName}
                            supplierName={itemByProduct.supplierName || ""}
                            onItemsChange={handleGroupItemsChange}
                            onCreateNewCustomer={onCreateNewCustomer}
                            customers={customers}
                            checkInOptionsMap={checkInOptionsMap}
                        />
                    );
                })}
                <BorderButton
                    $borderRadius="4px"
                    color="transparent"
                    $textColor={isSubmitting ? theme.colors.gray_6 : theme.colors.main}
                    type="submit"
                    disabled={isSubmitting}
                    onClick={() => handleSaveItems(false)}
                >
                    {isSubmitting ? "Saving ..." : "Save"}
                </BorderButton>
            </div>
            <div className="totalPriceContainer">
                <CheckoutItemsActions
                    btnTitle="Payment"
                    isSubmitting={isSubmitting}
                    onBtnClick={() => handleSaveItems(true)}
                    page="Checkout"
                />
            </div>
            {showPayNow && (
                <PaymentOptionBottomSheet
                    isOpen={showPayNow}
                    onClose={() => setShouldShowPayNow(false)}
                    handleOrderCreate={handleOrderCreate}
                    onOrderCreateSuccess={onOrderCreateSuccess}
                />
            )}
            {showPayNow && (
                <PaymentOptionBottomSheetDesktopView
                    isOpen={showPayNow}
                    onClose={() => setShouldShowPayNow(false)}
                    handleOrderCreate={handleOrderCreate}
                    onOrderCreateSuccess={onOrderCreateSuccess}
                />
            )}
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    font-family: Poppins;
    .cartWrapper {
        padding-right: 16px;
        ${breakpoint.breakOnlyMobile`
            padding-bottom : 100px;
        `}
    }
    ${breakpoint.breakTablet`
        & > .cartWrapper {
            width: ${(p) => p.theme.widths.wide_450};
        }
    `}

    ${breakpoint.breakIpadPro`
        & > .cartWrapper {
            width: ${(p) => p.theme.widths.wide_650};
        }
    `}
    ${breakpoint.breakLarge`
        & > .cartWrapper {
            width: ${(p) => p.theme.widths.wide_825};
        }
    `}

    ${breakpoint.breakOnlyMobile`
        display : block;
        padding: 16px 0px 0px 16px;
    `}

    .totalPriceContainer {
        ${breakpoint.breakLarge`
            width : 300px;
        `}

        ${breakpoint.breakOnlyMobile`
            position: fixed;
            bottom: 0;
            left: 0;
            background-color: white;
            z-index: 5;
            width : 100%;
        `}
    }
`;
